import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-curve-left",
  "use": "icon-curve-left-usage",
  "viewBox": "0 0 31.5 300",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.5 300\" id=\"icon-curve-left\"><title>curve-left</title><path d=\"M31.5,0a378.1,378.1,0,0,0,0,300H0V0Z\" transform=\"translate(0)\" /><path d=\"M53.75,188.75\" transform=\"translate(0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol